/**
 * Goal status type - Goals are ACHIEVED
 */
export type GoalStatus =
  | "ACTIVE"
  | "ARCHIVED"
  | "DROPPED"
  | "NOT_STARTED"
  | "IN_PROGRESS"
  | "MISSED"
  | "ACHIEVED";

export type GoalItem = {
  id: number;
  title: string;
  description?: string;
};

export type GoalsGroup = {
  id: number;
  group: string;
  description: string;
  goals: GoalItem[];
};

/** Category group the achiever's own (manually added) goals are filed under. */
export const MANUAL_GOALS_GROUP = "Your Goals";
